<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">      
      <div class="pledge-box1">   
        <div class="pledge-box1-top"> 
          <div class="Quarterly-Report" style="float: left;" v-if="allCustomerDate.length > 0">
            <div class="head-title"  @click.stop="showDateDropmemu($event)">
              {{ curCustomerDate }}
              <span class="close-bot"  @click.stop="showDateDropmemu($event)"></span>
            </div>
            <ul class="menu-lanmu" v-show="dateDropmenu">  
              <li v-for="h in allCustomerDate">
                <a href="javascript:;" v-if="curCustomerDate != h" @click="clickDropmenu(), curCustomerDate = h, customerFilter()">{{ h }}</a>
              </li>
            </ul>
          </div>


          <div class="Single-list-main" v-if="customerList.length > 0"> 
            <ul class="Single-list-box" v-for="(index, h) in customerList" track-by="$index">
              <li class="list-w">
                <p class="date">客户名称</p>
                <p class="time">{{ h.name }}</li>
              <li class="list-w">
                <p class="date">销售额</p>
                <p class="time">{{ h.money | money }}</p>
              </li>
              <li class="list-w">
                <p class="date">销售占比</p>
                <p class="time">{{ h.ratio }}</p>
              </li>
              <li class="list-w">
                <p class="date">排名</p> 
                <p class="time">{{ h.rank }}</p>
              </li> 
            </ul>
          </div>   

          <div class="Single-list-main" v-if="!customerList.length && !loading"> 
            <div class="Block-trade-no">暂无数据</div>
          </div>       
        </div> 
      </div>
    </div>
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'InvestView',
    mixins: [userMix, searchMix, comSearchMix, companyMix, wxshareMix],
    data () {
      return {
        customerList: [],
        customerListFilter: [],
        customerPerPage: 10,
        customerTotalPage: 0,
        curCustomerDate: '',
        allCustomerDate: [],
        customerSort: {
          xse: 0,
          xszb: 0,
          pm: 0,
        },
      }
    },
    route: {
      data({to}) {

        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;
          
          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);
          
          this.setSelectedTab();
          this.getCustomer();
        }
      }
    },
    methods: {
      getCustomer: function() {
        let query = {};
        query.companycode = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/customerlist'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.customerList = response.data;
            this.customerListFilter = response.data;
            this.customerTotalPage = Math.ceil(response.data.length / this.customerPerPage);


            if (response.data.length>0) {
              let tmp = {};
              for (let h of this.customerListFilter) {
                if (!tmp[h.reportdatestr]) {
                  tmp[h.reportdatestr] = true;
                  this.allCustomerDate.push(h.reportdatestr);
                }
              }

              // 筛选
              this.curCustomerDate = this.allCustomerDate[0];
              this.customerFilter();
              this.sortCustomer('money');
            }

            this.loading = false;
          } else {
            alert(response.description)
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
      customerFilter: function() {
        if (this.customerListFilter.length == 0) {
          return;
        }

        // $('.page-loading').css('display', 'block');
        this.loading = true;
        if (this.curCustomerDate && this.curCustomerDate!='') {
          let newArr = [];
          for (let h of this.customerListFilter) {
            if (this.curCustomerDate == h.reportdatestr) {
              newArr.push(h);
            }
          }
          this.customerList = newArr;
        }


        // $('.customer-table td.col').removeClass('col');
        if (this.customerSort.xse == 1) {
          this.customerSort.xse = 2;
          this.sortCustomer('money');
        } else if (this.customerSort.xse == 2) {
          this.customerSort.xse = 1;
          this.sortCustomer('money');
        }

        if (this.customerSort.xszb == 1) {
          this.customerSort.xszb = 2;
          this.sortCustomer('ratio');
        } else if (this.customerSort.xszb == 2) {
          this.customerSort.xszb = 1;
          this.sortCustomer('ratio');
        }

        if (this.customerSort.pm == 1) {
          this.customerSort.pm = 2;
          this.sortCustomer('rank');
        } else if (this.customerSort.pm == 2) {
          this.customerSort.pm = 1;
          this.sortCustomer('rank');
        }

        let that = this;
        setTimeout(function() {
          that.loading = false;
        }, 500);
      },
      sortCustomer: function(type) {
        // $('td.col').removeClass('col');
        if (!type) { return; }

        let _this = this;
        function changeIcon(key) {
          for (let k in _this.customerSort) {
            if (k == key) {
              if (_this.customerSort[k] == 1) {
                _this.customerSort[k] = 2
              } else {
                _this.customerSort[k] = 1;
              }
            } else {
              _this.customerSort[k] = 0;
            }
          }
        }

        let resource = this.customerList;

        // 销售额
        if (type=='money') {
          if (this.customerSort.xse==0 || this.customerSort.xse==2) {
            changeIcon('xse');
            resource.sort((a, b) => {
              return parseFloat(b.money) - parseFloat(a.money);
            });
          } else if (this.customerSort.xse == 1) {
            changeIcon('xse');
            resource.sort((a, b) => {
              return parseFloat(a.money) - parseFloat(b.money);
            });
          }
        }

        // 销售占比
        if (type=='ratio') {
          if (this.customerSort.xszb==0 || this.customerSort.xszb==2) {
            changeIcon('xszb');
            resource.sort((a, b) => {
              return parseFloat(b.ratio) - parseFloat(a.ratio);
            });
          } else if (this.customerSort.xszb == 1) {
            changeIcon('xszb');
            resource.sort((a, b) => {
              return parseFloat(a.ratio) - parseFloat(b.ratio);
            });
          }
        }

        // 排名
        if (type=='rank') {
          if (this.customerSort.pm==0 || this.customerSort.pm==2) {
            changeIcon('pm');
            resource.sort((a, b) => {
              return parseFloat(b.rank) - parseFloat(a.rank);
            });
          } else if (this.customerSort.pm == 1) {
            changeIcon('pm');
            resource.sort((a, b) => {
              return parseFloat(a.rank) - parseFloat(b.rank);
            });
          }
        }
        this.customerList = resource;

        // this.$nextTick(function() {
        //   //数据日期
        //   if (type=='money') {
        //     $('td.money').addClass('col');
        //   }
        //   //股票数量
        //   if (type=='ratio') {
        //     $('td.ratio').addClass('col');
        //   }
        //   //股票价值占比
        //   if (type=='rank') {
        //     $('td.rank').addClass('col');
        //   }
        // });
      },
      showDateDropmemu: function() {
        this.dateDropmenu = this.dateDropmenu ? false : true;
      },
      clickDropmenu: function() {
        this.dateDropmenu = false;
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }
</style>


/** WEBPACK FOOTER **
 ** Customer.vue?5149dcb0
 **/